import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from "chart.js";
import { getInventoryUsageForWorkshop } from "../../Api/Api";
import {useNotification} from "../Notification/NotificationContext";

// Register Chart.js components
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const InventoryUsageChart = ({ workshopId }) => {
    const [chartData, setChartData] = useState(null);
    const { showNotification } = useNotification();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getInventoryUsageForWorkshop(workshopId);
                generateChart(response.data);
            } catch (error) {
                showNotification(error.message, "error")
            }
        };

        fetchData();
    }, [workshopId]);

    const generateChart = (data) => {
        if (!data || data.length === 0) {
            setChartData(null);
            return;
        }

        const labels = data.map(item => item.itemName);
        const usedQuantities = data.map(item => item.totalUsed);
        const remainingStock = data.map(item => item.stockRemaining);

        setChartData({
            labels,
            datasets: [
                {
                    label: "Total Used",
                    data: usedQuantities,
                    backgroundColor: "rgba(255, 99, 132, 0.7)",
                },
                {
                    label: "Stock Remaining",
                    data: remainingStock,
                    backgroundColor: "rgba(54, 162, 235, 0.7)",
                }
            ],
        });
    };

    return (
        <div className="p-4 bg-white rounded-lg shadow-md">
            <h2 className="text-xl font-semibold mb-4">Inventory Usage Analysis</h2>
            {chartData ? (
                <Bar
                    data={chartData}
                    options={{
                        responsive: true,
                        plugins: {
                            legend: { position: "top" },
                            title: { display: true, text: "Inventory Usage Trends" },
                            tooltip: { callbacks: { label: context => `${context.raw} units` } },
                        },
                        scales: {
                            y: { title: { display: true, text: "Quantity" } },
                            x: { title: { display: true, text: "Inventory Items" } },
                        },
                    }}
                />
            ) : (
                <p>No inventory usage data available</p>
            )}
        </div>
    );
};

export default InventoryUsageChart;
